<template>
  <div
    class="group flex items-center border-b border-gray-700 px-4 transition-colors duration-150"
    :class="{ 'bg-primary-500/20': isSelected }">
    <Film size="14" class="mr-2 text-gray-400" />
    <div class="flex-1" @click="$emit('click')">
      <div class="text-gray-200">{{ name }}</div>
      <div v-if="label" class="text-sm text-gray-500">{{ label }}</div>
    </div>
    <button
      @click="$emit('delete')"
      class="ml-2 rounded p-1 opacity-0 transition-all duration-200 group-hover:opacity-100 hover:bg-red-500/20"
      title="Delete layer">
      <Trash2 size="14" class="text-red-400" />
    </button>
  </div>
</template>

<script setup>
import { Film, Trash2 } from 'lucide-vue-next';
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['delete', 'click']);
</script>
